<div class="ui-g-12 no-horizontal-padding text-left pair-container">
	<div class="pair-list">
		<div *ngFor="let pair of pairs"
			class="pair-item">
			<span class="pair-key">{{ pair.key }}: </span>{{ pair.value }}
		</div>
	</div>
</div>